
import PropTypes from 'prop-types'
import React from 'react'
import Switch from './Switch'
import ShowHide from './ShowHide'
import Overlay from './Overlay'
import Dialog from './Dialog'
import './FeaturesEditor.css'

const FeaturesEditor = props => (
  <div className='FeaturesEditor'>
    <button className='FeaturesEditor-toggle' onClick={props.toggleFeatureEditor} />

    <ShowHide show={props.isShowingFeatureEditor}>
      <Overlay visible onClick={props.toggleFeatureEditor}>
        <Dialog label='Feature Flags' onClose={props.toggleFeatureEditor}>
          <table>
            <thead>
              <tr>
                <th>feature</th>
                <th>enabled</th>
              </tr>
            </thead>
            <tbody>
              {props.features.map((feature, index) =>
                <tr key={`__featureseditor_feature_${index}_${feature.id}`}>
                  <td className='FeaturesEditor-id'>{feature.id}</td>
                  <td className='FeaturesEditor-switch'>
                    <Switch
                      checked={feature.enabled}
                      onChange={value => props.setFeatureFlag({ value, id: feature.id })} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </Dialog>
      </Overlay>
    </ShowHide>
  </div>
)

FeaturesEditor.propTypes = {
  features: PropTypes.array.isRequired,
  isShowingFeatureEditor: PropTypes.bool.isRequired,
  setFeatureFlag: PropTypes.func.isRequired,
  toggleFeatureEditor: PropTypes.func.isRequired
}

FeaturesEditor.displayName = 'FeaturesEditor'

export default FeaturesEditor



// WEBPACK FOOTER //
// ./ui/FeaturesEditor.js